var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5053_15643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 18.001C16.45 18.001 16 17.551 16 17.001C16 14.241 12.86 12.001 9 12.001C5.14 12.001 2 14.241 2 17.001C2 17.551 1.55 18.001 1 18.001C0.45 18.001 0 17.551 0 17.001C0 14.191 2.14 11.761 5.21 10.651C3.86 9.55098 3 7.87098 3 6.00098C3 2.69098 5.69 0.000976562 9 0.000976562C12.31 0.000976562 15 2.69098 15 6.00098C15 7.87098 14.14 9.55098 12.79 10.651C15.87 11.761 18 14.191 18 17.001C18 17.551 17.55 18.001 17 18.001ZM9 2.00098C6.79 2.00098 5 3.79098 5 6.00098C5 8.21098 6.79 10.001 9 10.001C11.21 10.001 13 8.21098 13 6.00098C13 3.79098 11.21 2.00098 9 2.00098Z",
    fill: "#EE2524"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5053_15643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a4d0b533.svg";
export { ForwardRef as ReactComponent };